module.exports = __webpack_public_path__ + "static/company_mobile-064cccee48c1aea0191d47d7b376f04f.png";